import * as React from 'react';
import classnames from 'classnames';

import { abbrNum, replaceString } from 'utils/helper/common';
import { renderPrice } from 'utils/helper/price';

type Props = {
  id: string,
  label: string,
  value: number
};

class CampaignAchievementsStatsCard extends React.PureComponent<Props> {
  static defaultProps = {
    value: 0
  };

  formatValue(id: string, value: number): number | string {
    const formattedNumber = abbrNum(value, { decimal: 1 });

    if (id === 'cost_per_post') {
      return renderPrice(`${formattedNumber} `, { separateThousands: false });
    }

    return formattedNumber;
  }

  render(): React.ReactNode {
    const { id, label, value } = this.props;
    const type = replaceString(id, '_', '-');
    const cardClasses = classnames({
      'campaign-achievements-stats-card': true,
      [`campaign-achievements-stats-card--type-${type}`]: type
    });

    return (
      <section className={cardClasses}>
        <h3 className="campaign-achievements-stats-card__title">{label}</h3>
        <span className="campaign-achievements-stats-card__value">{this.formatValue(id, value)}</span>
      </section>
    );
  }
}

export default CampaignAchievementsStatsCard;
